module.exports = __webpack_public_path__ + "assets/img/temporarysave.aaf70656.svg";